import select from './EmployerSelect.vue'
const EmployerSelect = {
	install: function(Vue) {
		Vue.component('EmployerSelect', select)
	}
}
export default EmployerSelect
